import { MakeCall } from './createMakeCall';

const markAllNotificationsAsRead = (makeCall: MakeCall) => () =>
  makeCall<undefined>('PUT', `/api/v2/notifications/read/all`);
export { markAllNotificationsAsRead };
